<template>
    <div class="charge-warp" v-loading="loading">
        <div class="display-f just-b">
            <el-form ref="form" :model="searchForm" label-width="55px" inline>
                <el-form-item label="日期：">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="searchForm.date" type="datetimerange"  :default-time="['00:00:00', '23:59:59']"
                        :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <custom-button type="primary" @click="handleSearch">查询</custom-button>
                    <custom-button type="" @click="reset">重置</custom-button>
                </el-form-item>
            </el-form>
            <custom-button type="primary" plain @click="handleExport">导出</custom-button>
        </div>
        <div class="table-warp">
            <customTable class="border-color" height="650" :cell-style="{ borderColor: '#DDDDDD' }"  :showPages="false" :tableData="tableData" :column="column" :total="total"
                :currentPage="searchForm.pageNum" :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }" border>
                <template slot="income">
                    <div>
                        <span>总收入 </span>
                        <el-tooltip class="item" effect="dark" content="总收入=收费-退费，包含挂号费+营业费+欠费订单已收费用" placement="top-start">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </div>
                </template>
                <template slot="payWay">
                    <div class="tac">总收入 - 按照支付方式统计</div>
                    <div class="payWay-warp mt20">
                        <div v-for="item in payWayList" :key="item.value" class="payWay-item">{{ item.label }}</div>
                    </div>
                </template>
                <template slot="register">
                    <div class="tac">挂号费</div>
                    <div class="payWay-warp mt20">
                        <div v-for="item in payWayListNotYB" :key="item.value" class="payWay-item">{{ item.label }}</div>
                    </div>
                </template>
                <template slot="turnover">
                    <div class="tac">营业额</div>
                    <div class="payWay-warp mt20">
                        <div v-for="item in payWayList" :key="item.value" class="payWay-item">{{ item.label }}</div>
                    </div>
                </template>
                <template slot="arrearage">
                    <div class="payWay-item">欠费订单已收费用<el-tooltip class="item" effect="dark"
                            content="该金额表示：存在部分收费的订单，无法将该笔费用分摊至挂号费或营业费。请及时将该类订单完成。" placement="top-start">
                            <i class="el-icon-question"></i>
                        </el-tooltip></div>
                </template>
                <template slot="collect">
                    <div class="tac">账目汇总</div>
                    <div class="payWay-warp mt20">
                        <div class="payWay-item">收费</div>
                        <div class="payWay-item">退费</div>
                    </div>
                </template>
                <template slot-scope="scope" slot="payWayAmount">
                    <div class="payWay-warp">
                        <div class="payWay-item" v-for="item in payWayList" :key="item.value">
                            <span v-if="item.value == '1'">{{ scope.row.payWay.ybMoney }}</span>
                            <span v-if="item.value == '2'">{{ scope.row.payWay.cashMoney }}</span>
                            <span v-if="item.value == '3'">{{ scope.row.payWay.howMuchMoney }}</span>
                            <span v-if="item.value == '4'">{{ scope.row.payWay.weChatMoney }}</span>
                            <span v-if="item.value == '5'">{{ scope.row.payWay.aliPayMoney }}</span>
                            <span v-if="item.value == '6'">{{ scope.row.payWay.bankCardMoney }}</span>
                            <span v-if="item.value == '7'">{{ scope.row.payWay.abcMoney }}</span>
                            <span v-if="item.value == '8'">{{ scope.row.payWay.walletMoney }}</span>
                            <span v-if="item.value == '9'">{{ scope.row.payWay.meituanMoney }}</span>
                            <span v-if="item.value == '10'">{{ scope.row.payWay.chequeMoney }}</span>
                            <span v-if="item.value == '12'">{{ scope.row.payWay.vipCardMoney }}</span>
                            <span v-if="item.value == '13'">{{ scope.row.payWay.jykMoney }}</span>
                            <span v-if="item.value == '14'">{{ scope.row.payWay.ybLineMoney }}</span>
                        </div>
                    </div>
                </template>
                <template slot-scope="scope" slot="registerAmount">
                    <div class="payWay-warp">
                        <div class="payWay-item" v-for="item in payWayListNotYB" :key="item.value">
                            <span v-if="item.value == '2'">{{ scope.row.register.cashMoney }}</span>
                            <span v-if="item.value == '3'">{{ scope.row.register.howMuchMoney }}</span>
                            <span v-if="item.value == '4'">{{ scope.row.register.weChatMoney }}</span>
                            <span v-if="item.value == '5'">{{ scope.row.register.aliPayMoney }}</span>
                            <span v-if="item.value == '6'">{{ scope.row.register.bankCardMoney }}</span>
                            <span v-if="item.value == '7'">{{ scope.row.register.abcMoney }}</span>
                            <span v-if="item.value == '8'">{{ scope.row.register.walletMoney }}</span>
                            <span v-if="item.value == '9'">{{ scope.row.register.meituanMoney }}</span>
                            <span v-if="item.value == '10'">{{ scope.row.register.chequeMoney }}</span>
                            <span v-if="item.value == '12'">{{ scope.row.register.vipCardMoney }}</span>
                            <span v-if="item.value == '13'">{{ scope.row.register.jykMoney }}</span>
                            
                        </div>
                    </div>
                </template>
                <template slot-scope="scope" slot="turnoverAmount">
                    <div class="payWay-warp">
                        <div class="payWay-item" v-for="item in payWayList" :key="item.value">
                            <span v-if="item.value == '1'">{{ scope.row.trade.ybMoney }}</span>
                            <span v-if="item.value == '2'">{{ scope.row.trade.cashMoney }}</span>
                            <span v-if="item.value == '3'">{{ scope.row.trade.howMuchMoney }}</span>
                            <span v-if="item.value == '4'">{{ scope.row.trade.weChatMoney }}</span>
                            <span v-if="item.value == '5'">{{ scope.row.trade.aliPayMoney }}</span>
                            <span v-if="item.value == '6'">{{ scope.row.trade.bankCardMoney }}</span>
                            <span v-if="item.value == '7'">{{ scope.row.trade.abcMoney }}</span>
                            <span v-if="item.value == '8'">{{ scope.row.trade.walletMoney }}</span>
                            <span v-if="item.value == '9'">{{ scope.row.trade.meituanMoney }}</span>
                            <span v-if="item.value == '10'">{{ scope.row.trade.chequeMoney }}</span>
                            <span v-if="item.value == '12'">{{ scope.row.trade.vipCardMoney }}</span>
                            <span v-if="item.value == '13'">{{ scope.row.trade.jykMoney }}</span>
                            <span v-if="item.value == '14'">{{ scope.row.trade.ybLineMoney }}</span>
                        </div>
                    </div>
                </template>
                <template slot-scope="scope" slot="collectAmount">
                    <div class="payWay-warp">
                        <div class="payWay-item">{{ scope.row.totalIncome }}</div>
                        <div class="payWay-item">{{ scope.row.totalRefund }}</div>
                        <!-- <div class="payWay-item">{{ scope.row.totalOwe }}</div> -->
                    </div>
                </template>
            </customTable>
        </div>
    </div>
</template>
  
<script>
import customTable from '@/components/customTable/customTable'
import { Utils } from '@/utils/utils'
import moment from 'moment';
import { statementDTO, CommonDTO } from '@/DTO/index'
import { debounce, isMoreThanOneYear } from '@/utils/validateBase'
export default {
    // 定义引入的组件
    components: { customTable },
    props: {},
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '今日',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '昨日',
                    onClick(picker) {
                        let yesterday = moment().subtract(1, 'days')
                        const end = Utils.timeFormat(Number(Utils.endOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本周',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本月',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本年',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                ]
            },
            searchForm: {
                date: [],
                deptId: this.$session.get('deptId'),
            },
            loading: false,
            tableData: [],
            total: 0,
            column: [
                { label: "日期", prop: "dealDate", minWidth: 116, align: 'left' },
                { label: "总收入", prop: "totalMoney", slotHeader: 'income', minWidth: 116, align: 'left' },
                { label: "支付方式（包含挂号费+营业费）", minWidth: 1400, slotHeader: 'payWay', slotName: 'payWayAmount', align: 'left' },
                { label: "挂号费", slotHeader: 'register', slotName: 'registerAmount', minWidth: 1200, align: 'left' },
                { label: "营业额", slotHeader: 'turnover', slotName: 'turnoverAmount', minWidth: 1400, align: 'left' },
                { label: "欠费订单已收费用", prop: 'totalOwe', slotHeader: 'arrearage', minWidth: 150, align: 'left' },
                { label: "账目汇总", slotHeader: 'collect', slotName: 'collectAmount', minWidth: 210, align: 'left' },
            ],
            payWayList: [],//支付方式列表(含医保)
            payWayListNotYB: [],//支付方式列表(不含医保)
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    async created() {
        this.init()
        this.payWayList = await CommonDTO.getPayWay()
        this.payWayListNotYB = this.payWayList.filter(item => { return item.value != '1' && item.value != '14' })
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 初始化数据
         */
        async init() {
            let time = CommonDTO.getSystemTimeDTO()
            let startOfDay = Number(Utils.startOfDay(time))
            let endOfDay = Number(Utils.endOfDay(time))
            this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
            this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
            this.getChargeReport()
        },
        /**
         * 搜索
         */
        handleSearch() {
            if(_.isEmpty(this.searchForm.date)){
                this.$message.error('请选择时间')
                return
            }
            let flag = this.searchForm.date&&isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 366)
            if (flag) return this.$message.error('时间范围不能超过一年')
            // let HH = this.$moment().get('hour')
            // let flagOneDay = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 1)
            // if(flagOneDay && HH < 22 && HH > 7 ) return this.$message.error('当前选择的日期范围大于1天，请22:00后查询')
            this.getChargeReport()
        },
        /**
         * 重置
         */
        reset() {
            this.init()
        },

        /**
         * 查询日报
         */
        getChargeReport() {
            this.loading = true
            this.searchForm.startDate = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
            this.searchForm.endDate = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')
            statementDTO.getChargeReport(this.searchForm).then(res => {
                this.loading = false
                let { code, data } = res
                if (code == 200) {
                    this.tableData = data
                }
            }).catch(() => {
                this.loading = false
            })
        },
        /**
         * 导出
         */
        handleExport: debounce(function () {
          this.searchForm.startDate = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
          this.searchForm.endDate = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')
          this.loading = true
          statementDTO.exportChargeReport(this.searchForm, { name: '收费日报' }).then(res => { 
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
          
        }, 1000, true),
    },
}
</script>
<style lang="less" scoped>
.charge-warp {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    .el-form-item {
        margin-bottom: 0;
    }

    .table-warp {
        margin-top: 16px;
        flex: 1;
        overflow-x: auto;
        /deep/.el-table{
            border-color: #DDDDDD;
            width: auto !important;
            max-width: none !important;
        }
        .payWay-warp {
            display: flex;

            .payWay-item {
                width: 104px;
                flex-shrink: 0;
                flex-grow: 0;
                box-sizing: border-box;
            }
        }
         /deep/.el-table__row{
            &:last-child{
                .cell{
                    font-weight: 600 !important;
                color: #1F2329 !important;
                }
                font-weight: 600 !important;
                color: #1F2329 !important;
            }
        }
    }
}
</style>